var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 40H13C9.96667 40 7.375 38.95 5.225 36.85C3.075 34.75 2 32.1833 2 29.15C2 26.55 2.78333 24.2333 4.35 22.2C5.91667 20.1667 7.96667 18.8667 10.5 18.3C11.3333 15.2333 13 12.75 15.5 10.85C18 8.95 20.8333 8 24 8C27.9 8 31.2083 9.35833 33.925 12.075C36.6417 14.7917 38 18.1 38 22C40.3 22.2667 42.2083 23.2583 43.725 24.975C45.2417 26.6917 46 28.7 46 31C46 33.5 45.125 35.625 43.375 37.375C41.625 39.125 39.5 40 37 40H26V25.7L29.2 28.8L32 26L24 18L16 26L18.8 28.8L22 25.7V40Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUpload);
export default __webpack_public_path__ + "static/media/icons_upload.b95de81c.svg";
export { ForwardRef as ReactComponent };